export default __webpack_public_path__ + "static/media/bg-call-end.3af59e1e.svg";